"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partitionSelectDependencies = void 0;

var _dependenciesCompareGenerated = require("./dependenciesCompare.generated.js");

var _dependenciesIsNaNGenerated = require("./dependenciesIsNaN.generated.js");

var _dependenciesIsNumericGenerated = require("./dependenciesIsNumeric.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var partitionSelectDependencies = {
  compareDependencies: _dependenciesCompareGenerated.compareDependencies,
  isNaNDependencies: _dependenciesIsNaNGenerated.isNaNDependencies,
  isNumericDependencies: _dependenciesIsNumericGenerated.isNumericDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createPartitionSelect: _factoriesAny.createPartitionSelect
};
exports.partitionSelectDependencies = partitionSelectDependencies;